import React from 'react';
import { Box, Typography, Grid, Link, Button, Avatar } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';
import ProfileServiceCard from '../publicProfile/ProfileServiceCard';
import ProfilePageCard from '../publicProfile/ProfilePageCard';

// Muestra ~5 tarjetas (≈216px c/u) y activa scroll cuando hay más
const scrollSx = (count, itemHeight = 216) => count > 5 ? {
  maxHeight: itemHeight * 5.4,
  overflowY: 'auto',
  pr: 1,
  '&::-webkit-scrollbar': { width: '6px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#D1D5DB', borderRadius: '10px' }
} : {};

const FavoritesList = ({ favorites }) => {
  const navigate = useNavigate();

  if (!favorites || favorites.length === 0) {
    return (
      <Box 
        sx={{ 
          textAlign: 'center', 
          py: 12,
          px: 4,
          bgcolor: 'white',
          borderRadius: '24px',
          border: '1px solid #F0F0F0',
          boxShadow: '0 4px 20px rgba(0,0,0,0.02)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '600px',
          gap: 3
        }}
      >
        <Avatar 
          sx={{ 
            bgcolor: '#FFD580', 
            width: 100, 
            height: 100,
            mb: 1
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 60, color: 'white' }} />
        </Avatar>
        
        <Box sx={{ maxWidth: '500px' }}>
          <Typography variant="h4" fontWeight="bold" color="#0E2465" sx={{ mb: 2 }}>
            Aún no tienes servicios guardados
          </Typography>
          <Typography variant="body1" color="#737791" sx={{ mb: 4, lineHeight: 1.6 }}>
            Cuando marques un servicio como favorito, aparecerá aquí para que puedas volver a él fácilmente cuando lo necesites.
          </Typography>
        </Box>

        <Button 
          variant="contained" 
          onClick={() => navigate('/home')}
          sx={{ 
            bgcolor: '#0E2465', 
            textTransform: 'none', 
            px: 4, 
            py: 1.5,
            fontWeight: 'bold',
            borderRadius: '8px',
            '&:hover': { bgcolor: '#0a1a4a' }
          }}
        >
          Explorar servicios
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Grid container spacing={2} sx={{ alignItems: 'center' }} >
        <Grid item size={{ xs: 12, sm: 8 }}>
          <Typography variant="h5" fontWeight="bold" color="primary">Tus Favoritos</Typography>
          <Typography variant="body2" color="#737791">Servicios y páginas que has guardado</Typography>
        </Grid>
        <Grid item size={{ xs: 12, sm: 4 }} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-end' } }}>
          <Link href="#" underline="hover" sx={{ color: 'primary', fontWeight: 'bold', fontSize: '14px' }}>
            Ver más ({favorites.length})
          </Link>
        </Grid>
      </Grid>

      <Box>
        {/* Sección de Servicios Individuales */}
        {favorites.some(item => !item.isPage) && (
          <Box sx={{ mb: 4 }}>
            <Typography variant="subtitle1" fontWeight="bold" color="#737791" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 4, height: 16, bgcolor: 'primary.main', borderRadius: 1 }} />
              Servicios Individuales
            </Typography>
            <Box sx={scrollSx(favorites.filter(item => !item.isPage).length)}>
              {favorites.filter(item => !item.isPage).map(item => (
                <ProfileServiceCard
                  key={item._id}
                  service={item}
                  user={{ _id: item.userId || '', name: item.authorName || 'Proveedor', avatar: item.authorAvatar }}
                />
              ))}
            </Box>
          </Box>
        )}

        {/* Sección de Páginas de Servicios */}
        {favorites.some(item => item.isPage) && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" color="#737791" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 4, height: 16, bgcolor: '#FF9900', borderRadius: 1 }} />
              Páginas de Grupos y Negocios
            </Typography>
            <Box sx={scrollSx(favorites.filter(item => item.isPage).length)}>
              {favorites.filter(item => item.isPage).map(item => (
                <ProfilePageCard
                  key={item._id}
                  page={item}
                  user={{ _id: item.userId || '', name: item.authorName || 'Proveedor', avatar: item.authorAvatar }}
                  isGroup={item.membersCount > 1}
                />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </Box >
  );
};

export default FavoritesList;
